import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, stringAvatar} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {ContractPageVO, useQueryContractPage} from "@/service/contract.s";
import {ReviewStatus} from "@/widget/ReviewStatus/ReviewStatus";
import {useAuthInfo} from "@/store/account.c";
import {WriteContract} from "@/pages/Contract/WriteContract";
import {ViewContract} from "@/pages/Contract/ViewContract";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {Avatar, ButtonGroup} from "@mui/material";
import Button from "@mui/material/Button";
import {NavigateBefore, NavigateNext, ArticleOutlined} from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import {permScope} from "@/helper/constant";
import {SellerAvatar} from "@/widget/SellerAvatar/SellerAvatar";

export const ContractListPage = () => {
    const {
        mutate: contractPageMutate,
        data: contractPageData,
        isPending: contractPagePending,
    } = useQueryContractPage()
    const {role: {dataScope}, id} = useAuthInfo()

    const columns: GridColDef<ContractPageVO>[] = [
        {field: "customerName", headerName: "客户名称", flex: 0.8, minWidth: 160},
        {
            field: "seller",
            headerName: "业务人员",
            headerAlign: "center",
            align: "center",
            flex: 0.7,
            display: 'flex',
            valueGetter: (_, row) => ({flag: 1, creator: row.creator, seller: row.seller}),
            renderCell: SellerAvatar
        },
        {
            field: "contractName",
            headerName: "合同名称",
            headerAlign: "left",
            align: "left",
            valueFormatter: value => value || "-"
        },
        {
            field: "contractNum",
            headerName: "合同编号",
            headerAlign: "center",
            align: "center",
            flex: 1
        },
        {
            field: "totalPrice",
            headerName: "总价",
            headerAlign: "center",
            align: "center",
            renderCell: ({row}) => {
                if (row.productTypeIds == "5") {
                    return <Typography color={'red'} component={'span'}>{row.contractName}</Typography>
                }
                return <Typography color={'red'} component={'span'}>{`${row.totalPrice}`}</Typography>
            }
        },
        {
            field: "dealTime",
            headerName: "成交日期",
            headerAlign: "right",
            align: "right",
            valueFormatter: (value) => formatTime("D", value),
        },
        {
            field: "nodeNames",
            headerName: "审核状态",
            headerAlign: "center",
            align: "center",
            flex: 1,
            renderCell: ({row}) => <ReviewStatus processorIds={row.processorIds} authId={id} auditStatus={row.auditStatus} nodeNames={row.nodeNames}/>,
        },
        {
            field: "createdAt",
            headerName: "创建时间",
            headerAlign: "right",
            align: "right",
            valueFormatter: (value) => formatTime("D", value),
        },
    ];

    return (
        <ProTable<ContractPageVO>
            loading={contractPagePending}
            columnVisibilityModel={{seller: dataScope !== permScope['self']}}
            renderDrawer={{view: <ViewContract mode={'drawer'}/>, write: <WriteContract/>}}
            columns={columns}
            data={contractPageData?.data}
            drawerProps={{
                view: {
                    headerHeight: 68, hiddenFooter: true, viewBtnCallback: (row: ContractPageVO) => {
                        return {
                            custom: true,
                            title: row.contractName,
                            businessId: row.id,
                            switchButton: <ButtonGroup size={'small'} sx={{
                                "& .MuiButton-startIcon": {marginRight: 0},
                                "& .MuiButton-endIcon": {marginLeft: 0}
                                , "& .MuiButtonGroup-grouped": {minWidth: 20, height: 20, width: 12, bgcolor: '#f2f4fb',}
                            }} variant="outlined">
                                <Button size={'small'} startIcon={<NavigateBefore/>}/>
                                <Button size={'small'} endIcon={<NavigateNext/>}/>
                            </ButtonGroup>,
                            icon: <ArticleOutlined color={'info'} fontSize={'small'}/>,
                            tags: <Stack direction={'row'} spacing={1.4} alignContent={'center'}>
                                <Chip size={'small'} variant={'outlined'} sx={{height: 16}} color={'warning'} label={<Typography fontSize={10}>{row.nodeNames}</Typography>}/>
                                <Chip sx={{height: 16}} size={'small'} variant={'outlined'} color={'error'} label={<Typography fontSize={10}>{row.contractNum}</Typography>}/>
                                <Chip sx={{height: 16}} size={'small'} variant={'outlined'} color={'success'} label={<Typography fontSize={10}>{row.productTypes}</Typography>}/>
                            </Stack>, instanceId: row.instanceId, updateForm: <WriteContract/>
                        }
                    }
                }
            }}
            onSearch={(params) => {
                contractPageMutate(params);
            }}
            code={"contract"}
        />
    );
};
